// Stats deck: a tilted stack of photo cards plus a stat bubble and result card that change together.
// Prev/next buttons and a gentle autoplay (paused on hover/focus, off with reduced motion) cycle the results.
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class StatsDeck extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.cards = [...this.querySelectorAll('[data-deck-card]')];
    this.swaps = [...this.querySelectorAll('.deck__swap')].map((swap) => [...swap.querySelectorAll(':scope > [data-deck-item]')]);
    this.dots = [...this.querySelectorAll('.deck__dots > span')];
    this.count = this.cards.length;
    this.index = 0;

    this.querySelector('[data-deck-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
    this.querySelector('[data-deck-next]')?.addEventListener('click', () => this.go(this.index + 1, true));

    this.addEventListener('pointerenter', () => this.stop());
    this.addEventListener('pointerleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.render();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  go(next, fromUser) {
    this.index = (next + this.count) % this.count;
    this.render();
    if (fromUser) { this.stop(); this.start(); }
  }

  render() {
    this.cards.forEach((card, i) => {
      card.dataset.pos = String((i - this.index + this.count) % this.count);
    });
    for (const items of this.swaps) {
      items.forEach((item, i) => item.classList.toggle('is-active', i === this.index));
    }
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
  }

  start() {
    if (reduceMotion.matches || this.timer) return;
    const interval = Number(this.dataset.interval) || 5000;
    this.timer = setInterval(() => this.go(this.index + 1, false), interval);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = 0;
  }
}

if (!customElements.get('s-stats-deck')) customElements.define('s-stats-deck', StatsDeck);
